import React, { Component } from 'react'
import { connect } from 'react-redux'
import Cookies from 'universal-cookie'
import { CSSTransitionGroup } from 'react-transition-group'

import './Feedback.scss'

class Feedback extends Component {
    constructor(props) {
        super()
        this.timeout = 0
        this.state = {
            visible: true,
            formId: props.formId || '12909',
        }
        this.cookies = new Cookies()
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.setState({
                visible: false,
            })
        }, 30000)
    }

    showFeedbackForm() {
        window.fby.push(['showForm', this.state.formId])
        // Push the events for close and submit
        window.fby.push([
            'onclose',
            () => {
                this.setCookie(14)
                this.setState({ visible: false })
            },
        ])
        window.fby.push([
            'onsubmit',
            () => {
                this.setCookie(28)
                this.setState({ visible: false })
            },
        ])
        return false
    }

    setCookie(daysTillExpiry) {
        if (!this.cookies.get('hideFeedbackify')) {
            // Only set the cookie if it does not exist. Otherwise it can get set multiple times in one session.
            let expiryDate = new Date()
            expiryDate.setDate(expiryDate.getDate() + daysTillExpiry)
            this.cookies.set('hideFeedbackify', true, { expires: expiryDate })
        }
    }

    render() {
        const { is_active, status } = this.props
        let visible =
            this.state.visible || (!is_active && status === 'In-Progress') ? '' : 'exitstrategy'
        if (this.cookies.get('hideFeedbackify')) {
            return null
        }
        return (
            <div>
                <CSSTransitionGroup
                    transitionName="Feedback__animation"
                    transitionAppear={true}
                    transitionAppearTimeout={1850}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}
                >
                    <div
                        key={visible}
                        className={`Feedback__cont ${visible}`}
                        onClick={() => {
                            this.showFeedbackForm()
                        }}
                    >
                        <div className="Feedback__main">
                            <div className="centermeplease">
                                <div className="centered">
                                    <span>FEEDBACK</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </CSSTransitionGroup>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        is_active: state.data.details && state.data.details.is_active,
        status: state && state.status,
    }
}

export default connect(mapStateToProps)(Feedback)
